import type { NewTeam, Team } from '~/constants/orgTypes'
import apiUtil, { throwApiError } from '~/utils/apiUtils'

const { get, patch, post, del } = apiUtil()

class TeamAPI {
  constructor() {}

  async getTeam(teamId: string): Promise<any> {
    try {
      const response = await get(`/team/${teamId}`)

      if (!response.ok) {
        await throwApiError(response)
      }

      const json = await response.json()
      return json
    } catch (error) {
      console.error('Error getting org:', error)
      throw error
    }
  }

  async getTeams(orgId: string): Promise<any> {
    try {
      const response = await get(`/team/org/${orgId}`)

      if (!response.ok) {
        await throwApiError(response)
      }

      const json = await response.json()
      return json
    } catch (error) {
      console.error('Error getting teams:', error)
      throw error
    }
  }

  async createTeam(team: NewTeam): Promise<any> {
    try {
      const response = await post(`/team/create`, team)

      if (!response.ok) {
        await throwApiError(response)
      }

      const json = await response.json()
      return json
    } catch (error) {
      console.error('Error creating org:', error)
      throw error
    }
  }

  async updateTeam(team: Team): Promise<any> {
    try {
      const response = await patch(`/team/update`, team)

      if (!response.ok) {
        await throwApiError(response)
      }

      const json = await response.json()
      return json
    } catch (error) {
      console.error('Error updating org:', error)
      throw error
    }
  }

  async addUserToTeam(teamId: string, userId: string): Promise<any> {
    try {
      const response = await post(`/team/add`, { teamId, userId })

      if (!response.ok) {
        await throwApiError(response)
      }

      const json = await response.json()
      return json
    } catch (error) {
      console.error('Error adding user to team:', error)
      throw error
    }
  }

  async removeUserFromTeam(teamId: string, userId: string): Promise<any> {
    try {
      const response = await del(`/team/${teamId}/users/${userId}`)

      if (!response.ok) {
        await throwApiError(response)
      }

      const json = await response.json()
      return json
    } catch (error) {
      console.error('Error removing user from team:', error)
      throw error
    }
  }

  async deleteTeam(teamId: string): Promise<any> {
    try {
      const response = await del(`/team/${teamId}`)

      if (!response.ok) {
        const errorData = await response.json()
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`)
      }

      const json = await response.json()
      return json
    } catch (error) {
      console.error('Error deleting team:', error)
      throw error
    }
  }
}

const teamApi = new TeamAPI()

export default teamApi
